export default __webpack_public_path__ + "static/investhk-08a45038d1f9c0e9393aa5dc1616e607.png";